import React from "react";
import { observer, inject } from 'mobx-react';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from '@material-ui/core/InputAdornment';
import Search from '@material-ui/icons/Search';
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
// import FormLabel from '@material-ui/core/FormLabel';
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel"
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from 'components/Grid/GridItem.jsx';
import SweetAlert from "react-bootstrap-sweetalert";
import Datetime from "react-datetime";
import moment from "moment-timezone";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

const styles = {
  ...extendedFormsStyle,
};

class SearchBox extends React.Component {
  async componentDidMount() {
    try {
      await this.props.category.loadCategories();
    } catch (error) {
      this.setState({
        alert: (
          <SweetAlert
            error
            style={{ display: "block", marginTop: "-100px" }}
            title={`Error !`}
            onConfirm={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            {`${error.message}`}
          </SweetAlert>
        )
      });
    }
  }

  handleMultiple = event => {
    this.props.search.changeCategorySelect(event.target.value);
  };

  handleStartDateChange = date => {
    this.props.search.changeField('startDate', new Date(date));
  };

  handleEndDateChange = date => {
    this.props.search.changeField('endDate', new Date(date));
  };

  change(value) {
    this.props.search.changeField('textSearch', value);
  }

  render() {
    // let history = useHistory();
    const { classes, history } = this.props;
    let { categorySelect, textSearch, startDate, endDate } = this.props.search;
    let { categories } = this.props.category;
    function clickSearch(props) {
      history.push(`/admin/dashboard`);
      const data = props.search.submitSearch('search');
      props.media.setMedias(data);
    }
    // const searchButton =
    //   classes.top +
    //   ' ' +
    //   classes.searchButton;
    return (

      <GridContainer style={{backgroundColor:'white',borderRadius:'5px', boxShadow: '0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12)'}}>
        {/* <GridItem xs={12} sm={3}>
          <h3>{title}</h3>
        </GridItem> */}
       
        <GridItem xs={6} sm={3}>
          <div style={{ marginTop: '3px' }}>
            Start
                <Datetime
              timeFormat={false}
              value={moment(startDate).tz('Asia/Bangkok').format('DD/MM/YYYY') || ''}
              onChange={this.handleStartDateChange}
              inputProps={{ placeholder: "Start Date" }}
            />
          </div>
        </GridItem>
        <GridItem xs={6} sm={3}>
          <div style={{ marginTop: '3px' }}>
            End
                <Datetime
              timeFormat={false}
              value={moment(endDate).tz('Asia/Bangkok').format('DD/MM/YYYY') || ''}
              onChange={this.handleEndDateChange}
              inputProps={{ placeholder: "End Date" }} />
          </div>
        </GridItem>
        <GridItem xs={6} sm={3}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel
              htmlFor="multiple-select"
              className={classes.selectLabel}
            >
              Choose Category
                          </InputLabel>
            <Select
              multiple
              value={categorySelect}
              onChange={this.handleMultiple}
              MenuProps={{ className: classes.selectMenu }}
              classes={{ select: classes.select }}
              inputProps={{
                name: "category",
                id: "category"
              }}
            >
              {categories.map((category) =>
                <MenuItem
                  key={category.id}
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelectedMultiple
                  }}
                  value={category.id}
                >
                  {category.name}
                </MenuItem>
              )
              }
            </Select>
          </FormControl>
        </GridItem>
        <GridItem xs={6} sm={3}>
          <CustomInput
            labelText="Search"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: event => this.change(event.target.value),
              value: `${textSearch || ''}`,
              placeholder: 'Search',
              endAdornment: (
                <InputAdornment position="end">
                  <Button
                    color="info"
                    // aria-label="edit"
                    justIcon
                    // round
                    // className={searchButton}
                    onClick={() => clickSearch(this.props)}
                  >
                    <Search className={classes.inputAdornmentIcon} />
                  </Button>
                </InputAdornment>
              ),
            }}
          />
        </GridItem>
       
      </GridContainer>

    )
  }
}

export const page = inject('search', 'category', 'media')(observer(SearchBox));
export default withStyles(styles, { withTheme: true })(page);
